import { css } from '@emotion/react'
import { Alert, Heading, Link, Theme, useTheme, VFlow } from 'bold-ui'
import { useHistory } from 'react-router'

import { NewsModalBodyLinks } from './NewsModalBodyLinks'

type newsModalBodyTypes = {
  handleModalClose?: () => void
}

export function NewsModalBody({ handleModalClose }: newsModalBodyTypes) {
  const history = useHistory()
  const theme = useTheme()
  const styles = createStyles(theme)

  const handleOnNovidadesVersaoClicked = () => {
    handleModalClose()
    history.push('/novidades')
  }

  return (
    <VFlow>
      <Alert type='info' inline>
        <strong>O PEC é frequentemente aprimorado com melhorias e correções!</strong> Para conhecer as próximas
        novidades, o sistema deve ser atualizado com a versão mais recente disponível.
      </Alert>

      <VFlow>
        <Heading level={4}>Clique em um dos itens para visualizar as novidades:</Heading>
        <NewsModalBodyLinks onLinkClick={handleModalClose} />
      </VFlow>

      <VFlow>
        <Heading level={4}>Para acessar as Novidades da Versão:</Heading>
        <p>
          No cabeçalho do sistema, abra o menu clicando sobre seu nome e em seguida na opção{' '}
          <Link onClick={handleOnNovidadesVersaoClicked}>Novidades da versão</Link>.
        </p>
        <video
          css={styles.video}
          src='/static/novidades/modal_notificacao.webm'
          aria-label='Vídeo de como acessar novidades da versão'
          autoPlay
          loop
          muted
          playsInline
        />
      </VFlow>
    </VFlow>
  )
}

const createStyles = (theme: Theme) => ({
  video: css`
    width: 100%;
    height: 15.625rem;
    object-fit: cover;
    object-position: 0 30%;
    border: 1px solid ${theme.pallete.gray.c80};
    border-radius: ${theme.radius.button}px;
  `,
})
